export enum BonusUserDomainEnum {
  SHRL = 1,
}

export enum BonusTypeEnum {
  Bonus = 1,
  Challenge,
}

export enum BonusCategoryEnum {
  Daily = 1,
  Weekly,
  Monthly,
}

export enum RewardTypeEnum {
  ALL = 0,
  SHRL = 1,
  USD,
  DailyDraw,
  WeeklyDraw,
  MegaDraw,
  DepositCashback,
  FreeBet,
  FreeSpin,
}

export enum BonusApplyOnTypeEnum {
  Provider = 1,
  GameCategory,
  SpecificGame = 3,
}
